import { render, staticRenderFns } from "./ProductCatalog.vue?vue&type=template&id=4fe69991&scoped=true&"
import script from "./ProductCatalog.vue?vue&type=script&lang=ts&"
export * from "./ProductCatalog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCatalog.vue?vue&type=style&index=0&id=4fe69991&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe69991",
  null
  
)

export default component.exports